import './Scores.css';
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';

import config from '@config';
import Metas from '@views/Metas';
import UserScores from '@views/ScoresExplainer';
import Announcement from '@views/Announcement';

export const Scores = ({ username }) => (
  <div className="Scores">
    <Metas
      title={`Puntaje de ${username} en el Prode Mundial 2026`}
      description="El juego de Página|12 para predecir los resultados del Mundial de Fútbol 2026"
    />
    <Announcement />
    <div className="hero-bg">
      {username ? (
        <div className="hero-content">
          <h2>Puntajes de {username}</h2>
          <p>
            Revisá cuántos puntos sumó <b>{username}</b> en cada partido en
            función de sus pronósticos y los resultados reales de los
            encuentros. Puede tardar hasta 24 horas en actualizarse.
          </p>
        </div>
      ) : (
        <div className="hero-content">
          <h2>Mis puntajes</h2>
          <p>
            Revisá cuántos puntos sumaste en cada partido en función de tus
            pronósticos y los resultados reales de los encuentros. Puede tardar
            hasta 24 horas en actualizarse.
          </p>
        </div>
      )}
    </div>
    <div className="scores-content">
      <div className="card">
        <UserScores />
      </div>
    </div>
  </div>
);

Scores.displayName = 'Scores';
Scores.propTypes = {
  username: PropTypes.string,
};
Scores.defaultProps = {
  username: '',
};

export const mapStateToProps = (state) => ({
  username: get(state, 'scores.username'),
});

export default connect(mapStateToProps)(Scores);
